<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
import Tickets from "../../../mixins/Tickets";
import ReportingInterfaceWrapper from "./show/ReportingInterfaceWrapper";
import ReportingToolbar from "./show/ReportingToolbar";
import ReportingMainSection from "./show/ReportingMainSection";
import ReportingMainSectionLeftColumn from "./show/ReportingMainSectionLeftColumn";
import ReportingMainSectionSidebar from "./show/ReportingMainSectionSidebar";
import {mapGetters, mapActions} from "vuex";

/**
 * Reporting-view component
 */
export default {
  page: {
    title: "Create New Report",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Tickets],
  components: {
    ReportingInterfaceWrapper,
    Layout,
    PageHeader,
    ReportingToolbar,
    ReportingMainSection,
    ReportingMainSectionLeftColumn,
    ReportingMainSectionSidebar
  },
  computed: {
    ...mapGetters('reportEditor', {
      isLoading: 'isLoading',
      report: 'report'
    })
  },
  data() {
    return {
      title: "Edit Report",
      items: [
        {
          text: "Reporting",
          href: "/reporting"
        },
        {
          text: "Edit Report",
          active: true
        }
      ]
    };
  },
  mounted() {
  },
  watch: {
    $route(newRoute) {
      this.refreshRoute();
    }
  },
  created() {
    this.loadAgents();
    this.loadTravelConsultantNames();
    this.refreshRoute();
  },
  methods: {
    ...mapActions('reportEditor', {
      loadReport: 'loadReport',
      loadAgents: 'loadAgents',
      loadTravelConsultantNames: 'loadTravelConsultantNames',
      blankSlate: 'blankSlate'
    }),

    refreshRoute() {
      if (this.$route.params.id) {
        this.loadReport(this.$route.params.id);
      } else {
        this.blankSlate();
      }
    }
  }
};
</script>

<template>
  <Layout :full-width="true">
    <loading-screen :is-loading="isLoading"></loading-screen>
    <ReportingInterfaceWrapper v-if="report">
      <ReportingToolbar></ReportingToolbar>
      <ReportingMainSection>
        <ReportingMainSectionLeftColumn></ReportingMainSectionLeftColumn>
        <ReportingMainSectionSidebar></ReportingMainSectionSidebar>
      </ReportingMainSection>
    </ReportingInterfaceWrapper>
  </Layout>
</template>

<style scoped></style>